import { valueTypes } from 'pages/rule-configuration/components/AddCustomizationModal/view';

const ValueType: Record<(typeof valueTypes)[number], string> = {
  s: 'Static',
  r: 'Regex',
  f: 'Function',
  e: 'Exists',
};

export default ValueType;
